import React, { useState, useEffect } from "react";
import Header from "../../components/common/header/Header";
import Select from "react-select";

import PhoneInput, {
  parsePhoneNumber,
  isValidPhoneNumber,
} from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { Link, useNavigate } from 'react-router-dom';
import Footer from "../../components/common/footer/Footer";
import { toast } from "react-toastify";

import { UserLogin } from "../../api/auth_api/Auth_Api";
import Loader from "../../loader/Loader";
import Astrologer_Header from "../../components/pages/astrologer/astrologer_header/Astrologer_Header";
import { get_Page_Seo } from "../../api/global/Global";
import { IMG_BASE_URL, WEB_DOMAIN_KEY } from "../../config/Config";
import { Helmet } from "react-helmet";

const Astrologer_Login = () => {
  const navigate = useNavigate()
  const [pageSeo, set_Page_Seo] = useState({})

  const [isLoading, setIsLoading] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("+91");
  const [mobileNumber, setMobileNumber] = useState("");
  const [countryCode, setCountryCode] = useState("IN");
  const [isValid, setIsValid] = useState(false);
  const [role, setRole] = useState(null);
  const [notify_Popup, set_NotifyPopup] = useState(false)
  const [userStatus, setUserStatus] = useState(null)
  const user_Roles = [
    { value: "2", label: "Astrologer" },
    { value: "3", label: "Pandit" },

  ];

  // <----------------get seo metadata------------->
  useEffect(() => {
    const Get_Page_Seo = async () => {
      setIsLoading(true);
      try {
        const response = await get_Page_Seo()
        console.log("PageSeo:", response);
        if (response?.data?.status == 200) {
          const seo = response?.data?.data?.seo
          const filterSeoPage = seo?.find(page => page?.page_name === "Astro/Pandit Login")
          set_Page_Seo(filterSeoPage)
        }
      } catch (error) {
        console.error(error)
      } finally {
        setIsLoading(false);
      }
    }

    Get_Page_Seo()
  }, [])
  // <----------- Onchnage Events on the Phone Input section's -------------->
  const handlePhoneChange = (value) => {
    if (!value || !value.startsWith("+")) {
      setPhoneNumber("+91");
      setCountryCode("91");
      setMobileNumber("");
      return;
    }

    setPhoneNumber(value);

    try {
      const parsedPhone = parsePhoneNumber(value);
      setCountryCode(parsedPhone.countryCallingCode);
      setMobileNumber(parsedPhone.nationalNumber);
    } catch (error) {
      setMobileNumber("");
    }
  };
  // <----------- Handle Key Down Events on the Phone Input section's -------------->
  const handleKeyDown = (e) => {
    // Prevent deleting the "+" or the country code
    if (
      (e.key === "Backspace" || e.key === "Delete") &&
      phoneNumber &&
      phoneNumber.length <= 3 // block when cursor is within "+91"
    ) {
      e.preventDefault();
    }
  };
  // <--------- User Login Section's here ----------------------->
  const HandleUserLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true)
    const user_login_data = {
      mobile: mobileNumber,
      country_code: `+${countryCode}`,
      user_role: role,
    };
    if (!isValid) {
      toast("Please enter a valid phone number containing only numbers.");
      setIsLoading(false)
      return;
    }
    console.log("user_login_data", user_login_data);
    try {
      const response = await UserLogin(user_login_data);
      // console.log("astro-login",   response);

      if (response?.data?.status == "200") {
        const userdata = response?.data?.data?.user
        setIsLoading(false)
        if (userdata?.profile_step !== 3) {
          navigate("/astrologer-login-otp-Verify", {
            state: {
              mobile: mobileNumber,
              country_code: `+${countryCode}`
            }
          })
          return
        }
        if (userdata?.profile_step == 3) {
          if (userdata?.accept_status == "accepted") {
            navigate("/astrologer-login-otp-Verify", {
              state: {
                mobile: mobileNumber,
                country_code: `+${countryCode}`
              }
            })
            return
          }
          if (userdata?.accept_status !== "accepted") {
            const userStatus = response?.data?.data?.user?.accept_status

            setUserStatus(userdata?.accept_status)
            set_NotifyPopup(true)
            setTimeout(() => {
              set_NotifyPopup(false)
              // navigate("/astrologer-login")
            }, 5000)
            return;
          }
        }

      }
      else if (response?.response?.data?.status == false) {
        toast(response?.response?.data?.message)
        setIsLoading(false)
      }
      else if (response?.response?.data?.status == "500") {
        toast(response?.response?.data?.message)
        setIsLoading(false)
      }
    } catch (error) {
      setIsLoading(false)
      console.log("error", error)
    }
  };

  const handleclosePopup = () => {
    set_NotifyPopup(false)
    // navigate('/astrologer-login')
  }

  // <-------- Apply for the Phone Number Validtion According to the Country and Country code here ----------->
  useEffect(() => {
    setIsValid(isValidPhoneNumber(phoneNumber));
  }, [phoneNumber]);

  // <------- clear the local storage --------->
  useEffect(() => {
    localStorage.clear("")
  })

  const handleRoleChange = (selectedOption) => {
    console.log("Selected role:", selectedOption);

    setRole(selectedOption ? selectedOption.value : null);
  };


  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
      <Helmet>
        <title>{pageSeo?.meta_title}</title>
        <meta name="description" content={pageSeo?.meta_description} />
        <link rel="canonical" href={`${WEB_DOMAIN_KEY}astrologer-login`} />
        <link rel="alternate" hreflang="en-us" href={`${WEB_DOMAIN_KEY}astrologer-login`} />

      </Helmet>
      <div>
        {/* <-------- ToastContainer ------------> */}
        {/* <ToastContainer style={{ marginTop: "120px" }} /> */}
        {/* <------- Header section's ------------> */}
        <Astrologer_Header />
        {/* <------ User Login section's ---------> */}

        <section className='banner-section'>
          <div className={`${pageSeo?.image ? "block" : "hidden"} relative`}>
            <img src={`${IMG_BASE_URL}${pageSeo?.image}`} alt={pageSeo?.alt
            } className='w-full h-[300px]' />


          </div>
        </section>
        <section className="gi-register bg-[#F0F4F8] py-[40px] max-[767px]:py-[30px] min-h-screen w-full overflow-x-hidden">
          {isLoading ? (
            <Loader />
          ) : (
            <div className="w-full px-4 sm:px-6 lg:px-8">
              <div className="flex flex-wrap justify-between items-center mx-auto max-w-[720px] sm:max-w-[540px] bg-white p-5 rounded-lg">
                <div
                  className="gi-login-box w-full px-[15px] max-[991px]:w-full max-[991px]:px-0"
                  id="login_modal"
                >
                  <div className="section-title-2 w-full mb-[20px] pb-[20px]">
                    <h2 className="gi-title mb-0 font-Poppins text-[26px] font-semibold text-[#4b5966] relative inline capitalize leading-[1]">
                      Login Account
                    </h2>
                    <p className="max-w-[400px] mt-[15px] text-[14px] text-[#777] leading-[23px]">
                      If you have an account with us, please log in.
                    </p>
                  </div>

                  <div className="gi-login-wrapper mx-auto">
                    <div className="gi-login-container">
                      <div className="gi-login-form">
                        <form
                          action="#"
                          method="post"
                          className="flex flex-col"
                          onSubmit={HandleUserLogin}
                        >
                          <div className="gi-login-wrap flex flex-col">
                            <div className="gi-login-wrap flex gi-register-half w-[100%] flex-col">
                              <label
                                className="mb-[10px] text-gray-700 text-[13px} font-medium tracking-[0] leading-[1]">
                                Role</label>
                              <Select
                                options={user_Roles}
                                isSearchable={false}

                                name="role"
                                value={user_Roles.find(role => role.value === role)}
                                onChange={handleRoleChange}
                                placeholder="Select Roles"
                                className="react-select-container mb-[15px] text-[12px] font-medium p-1 text-gray-700 bg-white border rounded-lg"
                                styles={{
                                  control: (base, state) => ({
                                    ...base,
                                    border: "none",
                                    boxShadow: state.isFocused ? "none" : "none"
                                  })
                                }}
                              />
                            </div>
                            <div className="form-group">
                              <label htmlFor="phone">Phone Number</label>
                              <PhoneInput
                                international
                                value={phoneNumber}
                                defaultCountry={countryCode}
                                onChange={handlePhoneChange}
                                onKeyDown={handleKeyDown}
                                maxLength={15}
                                className="w-full mb-[15px] px-[15px] bg-transparent border border-[#eee] rounded-[5px] text-[#777] text-[14px] outline-none h-[50px]"
                                placeholder="Enter phone number"
                              />
                              {!isValid && (
                                <span className="text-red-500 text-sm">
                                  Please enter a valid phone number
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="gi-login-wrap">
                            <button
                              type="submit"
                              id="showLink"
                              className="w-full mt-[20px] block p-[14px] text-center text-white bg-gradient-to-r from-[#9F2225] to-[#FFB500] rounded-[5px] text-[16px] outline-none h-[50px]"
                            >
                              Send OTP
                            </button>
                          </div>

                          <span className="gi-login-wrap gi-login-btn mt-[20px] flex flex-row justify-center gap-3 items-center">
                            <span className="text-[#777] text-[14px]">
                              Don't have an account?
                            </span>
                            <Link
                              to="/astrologer-register"
                              className="gi-btn-1 btn py-[8px] px-[15px] text-[#9F2225] border-0 transition-all duration-300 ease-in-out text-center text-[14px] font-semibold relative rounded-[5px] hover:text-[#333]"
                            >
                              Create Account
                            </Link>
                          </span>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </section>
        {
          notify_Popup && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="bg-white rounded-2xl shadow-2xl p-8 w-[90%] max-w-md text-center relative animate-fadeIn">
                {/* Close button */}
                {/* <button
                                            onClick={handleclosePopup}
                                            className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-xl"
                                        >
                                            &times;
                                        </button> */}

                {/* Icon */}
                <div className="flex justify-center mb-4">
                  <div className="bg-yellow-100 p-4 rounded-full">
                    <svg
                      className="w-10 h-10 text-yellow-500"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 
                  1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L4.34 
                  16c-.77 1.333.192 3 1.732 3z"
                      />
                    </svg>
                  </div>
                </div>

                {/* Title */}
                <h2 className="text-xl font-semibold text-gray-800 mb-2">
                  Access {userStatus}
                </h2>

                {/* Message */}
                <p className="text-gray-600 mb-6 text-sm">
                  You can login when your request is accepted by the admin.
                </p>

                {/* Button */}
                <button
                  onClick={handleclosePopup}
                  className="bg-yellow-500 hover:bg-yellow-600 text-white font-medium px-6 py-2 rounded-lg shadow-md transition"
                >
                  Okay, Got it
                </button>
              </div>
            </div>
          )
        }
        {/* <-------- Footer section's ------------> */}
        <Footer />
      </div>
    </>
  );
};

export default Astrologer_Login;
